import { isApiErrorDto } from "../../common/errors/isApiErrorDto";
import { isFetchBaseQueryError } from "../../common/errors/isFetchBaseQueryError";
import { useEffect, useState } from "react";

export const isBeforeBidDeadline = (deadline: string | null | undefined) =>
  !!deadline && new Date(deadline).getTime() > Date.now();

// setTimeout fires at once for any delay above 2^31 - 1 ms (about 24.8 days), so longer waits are not scheduled
const MAX_TIMEOUT_MS = 2_147_483_647;

export const useHasPassed = (instant: string | null | undefined): boolean => {
  const [hasPassed, setHasPassed] = useState(false);
  useEffect(() => {
    setHasPassed(false);
    if (!instant) return;
    const remaining = new Date(instant).getTime() - Date.now();
    if (remaining <= 0 || remaining > MAX_TIMEOUT_MS) return;
    const timer = setTimeout(() => setHasPassed(true), remaining);
    return () => clearTimeout(timer);
  }, [instant]);
  return hasPassed;
};

const DEADLINE_REFUSALS = new Set([
  "zz_SourcingEventApiErrorCode_CannotInviteWithoutBidDeadline",
  "zz_SourcingEventApiErrorCode_InviteThroughTheOpenChange",
]);

export const isDeadlineRefusal = (e: unknown): boolean =>
  isFetchBaseQueryError(e) && isApiErrorDto(e.data) && DEADLINE_REFUSALS.has(e.data.errorCode ?? "");
